/*
 *
 * File: types.js
 *
 * Purpose: Declarations of redux reducer types as constants.
 *
 * Author:  Thomas Burgard (Software development)
 * Created: 23.02.2022
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

export const GET_USERDATA = "get_userdata_response";
export const GET_PASSENGERDATA = "get_passengerdata_response";
export const GET_PASSENGER_BOOKINGS = "get_passenger_bookings_response";
export const GET_BOOKINGDATA = "get_bookingdata_response";
export const CHANGE_LANGUAGE = "change_language";
export const CLEAR_USERDATA_IN_STATE = "clear_user_data_in_state";

